import React,{ useState, useEffect } from 'react';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { useStateContext } from '../../contexts/ContextProvider';
import {useCarpetasMutations} from '../../hooks';
import {getCarpetasFiltros} from "../../services/Carpetas";
import {formatDate} from '../../formatters/date';
import { getCentroCosto } from "../../services/CentroCostos";
import DataTable from 'react-data-table-component';
import { NuevaCarpeta } from '../../components';
import { toast } from 'react-hot-toast';
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const Carpetas = () => {
  const { handleClick, isClicked } = useStateContext();
  const {removeCarpeta} = useCarpetasMutations();
  const [estado, setEstado] = useState('ALL');
  const [proyecto, setProyecto] = useState('ALL');
  const [numeroCarpeta, setNumeroCarpeta] = useState("");
  const [numeroInterno, setNumeroInterno] = useState("");
  const [serie, setSerie] = useState("");
  const [patente, setPatente] = useState("");

  const [proyectosData, setProyectosData] = useState([]);
  const [archivosData, setArchivosData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [numeroSolicitud, setNumeroSolicitud] = useState('');
  const [centroCosto, setCentroCosto] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const misProyectos = await getCentroCosto();
      setProyectosData(misProyectos);  
    };
    fetchData();
  },[]);

  useEffect(()=>{
    const fetchData = async () => {
      const docuData = await getCarpetasFiltros(numeroSolicitud,numeroCarpeta,serie,patente,proyecto,estado,numeroInterno );
      // console.log("DATA -> ", JSON.stringify(docuData));
      setArchivosData(docuData);
    };
    fetchData();
  },[numeroSolicitud,numeroCarpeta,serie,patente,proyecto,estado, numeroInterno]);

  const handleChangeProyecto = (e) =>{
    setProyecto( e.target.value );
  }

  const handleChangeNumeroCarpeta = (e) => {
    setNumeroCarpeta( e.target.value );
  };

  const handleChangeNumeroInterno = (e) => {
    setNumeroInterno( e.target.value );
  }

  const handleChangeSerie = (e) => {
    setSerie( e.target.value );
  };

  const handleChangePatente = (e) => {
    setPatente( e.target.value );
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevaCarpeta');
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    if(row.estado ==="Pendiente"){
      await removeCarpeta.mutateAsync(row._id);
      setArchivosData((prevData) => prevData.filter((item) => item._id !== row._id));
    } else {
      toast.error('Carpeta no puede ser eliminada.');
      return;
    }
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
  
        const docuData = await getCarpetasFiltros(numeroSolicitud,numeroCarpeta,serie,patente,proyecto,estado, numeroInterno);
        setArchivosData(docuData);

      };
      fetchData();
    }
  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'N° Sol',
      width: '120px',
      selector: row => row.idSolicitud.numeroSolicitud,
      sortable: true
    },
    {
      name: 'Centro Costo',
      width: '130px',
      selector: row => row.idCentro?.codigo,
      sortable: true
    },
    {
      name: 'Fecha Obra',
      width: '160px',
      selector: row => {
        const detalle = row.idSolicitud?.detalleEquipos?.find(d => d.lin === row.lin);
        return detalle?.fechaEnObra ? formatDate(detalle.fechaEnObra) : '-';
      },
      sortable: true
    },
    {
      name: 'N° interno',
      width: '140px',
      selector: row => row.codigoEquipo,
      sortable: true
    },
    {
      name: 'Maquina',
      width: '250px',
      selector: row => row.idMaquina.nombreMaquina,
      sortable: true
    },

    {
      name: 'Proyecto',
      width: '300px',
      selector: row => row.idCentro.nombreProyecto,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.idCentro.nombreProyecto}</span>
      </div>
      )
    },

        {
    name: 'Estado',
    width: '120px',
    selector: row => row.estado,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estado) {
        case 'Aprobado':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        case 'Rechazada':
          bgColor = 'bg-red-100 text-red-700';
          break;
        case 'En Revisión':
          bgColor = 'bg-blue-100 text-blue-700';
          break;
        case 'Salida de Obra':
          bgColor = 'bg-gray-100 text-gray-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estado}
        </div>
      );
    }
  },
      {
      name: 'Serie',
      width: '160px',
      selector: row => row.serie,
      sortable: true
    },
    {
      name: 'Patente',
      width: '160px',
      selector: row => row.patente,
      sortable: true
    },
    {
      name: 'Tipo',
      width: '120px',
      selector: row => row.idSolicitud.tipoSolicitud,
      sortable: true
    },
    {
      name: 'Fecha Carpeta',
      width: '150px',
      selector: row => formatDate(row.fechaCreacion),
      sortable: true
    },
    {
      name: 'N° Carpeta',
      width: '150px',
      selector: row => row.numeroCarpeta,
      sortable: true
    }

  ];

  const filteredData = centroCosto
    ? archivosData.filter(row => row.idCentro?.codigo?.toLowerCase().includes(centroCosto.toLowerCase()))
    : archivosData;

  return (

<>
  <div className="mx-4 lg:mx-12 mt-4">
    <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
          <p className="text-gray-800 font-semibold text-base md:text-lg">
            Carpetas
          </p>
        </div>
    </div>
    <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
      <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-2 md:grid-cols-8 gap-4 mt-2 justify-between" >
              {/* N° Solicitud */}
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Solicitud</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 10234"
                value={numeroSolicitud}
                onChange={(e) => setNumeroSolicitud(e.target.value)}
              />
            </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Carpeta</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder=""
                  name="numeroInterno"
                  value= {numeroCarpeta}
                  onChange={handleChangeNumeroCarpeta}
                />
              </div>    
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Interno</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder=""
                  name="numeroInterno"
                  value= {numeroInterno}
                  onChange={handleChangeNumeroInterno}
                />
              </div>   
              <div className="flex flex-col mr-2">
                <label className="text-xs font-semibold mb-1">Serie</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder=""
                  name="serie"
                  value= {serie}
                  onChange={handleChangeSerie}
                />
              </div>  
              <div className="flex flex-col mr-2">
                <label className="text-xs font-semibold mb-1">Patente</label>
                <input
                    type="text"
                    className="text-xs border border-gray-300 p-2 rounded"
                    placeholder=""
                    name="patente"
                    value= {patente}
                    required
                    onChange={handleChangePatente}
                />
              </div>
              <div className="flex flex-col mr-2">
                <label className="text-xs font-semibold mb-1">Centro Costo</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder="Ej: CC-001"
                  value={centroCosto}
                  onChange={(e) => setCentroCosto(e.target.value)}
                />
              </div>
              <div className="col-span-2">
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Proyecto</label>
                    <select className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300" name="proyecto" value= {proyecto} required onChange={handleChangeProyecto}>   
                      <option value="ALL">Todos</option>
                        {proyectosData?.map((item, index) => (
                          <option key={item._id} value={item._id}>{item.nombreProyecto}</option>
                        ))}    
                    </select>
                </div> 
              </div>
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En Revisión">En Revisión</option>
                  <option value="Aprobado">Aprobado</option>
                  <option value="Rechazada">Rechazada</option>
                  <option value="Salida de Obra">Salida de Obra</option>
                  </select>
              </div>  
           {/*  <div className="flex flex-col justify-end">
                  <NavButton title="Agregar Carpeta" customFunc={() => { setLaSucursal(''); handleClick('nuevaCarpeta')} } color={currentColor} icon={<AiFillFileAdd />} texto={'Carpeta'} />
                </div>
            */}
          </div>
      </div>
    </div>

      <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
              <DataTable
                columns={columns}
                data={filteredData}
                highlightOnHover
                pagination={true}
                striped
                className="border border-gray-300 rounded-lg shadow-sm"
                noHeader={true}
                selectableRowsHighlight
                customStyles={customStyles}
                noDataComponent={'No hay Solicitudes creadas'}
              />
            </div>
        </div>
      </div>
     {isClicked.nuevaCarpeta && (<NuevaCarpeta vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
  </div>

    </>
  );
};

export default Carpetas;